// extracted by mini-css-extract-plugin
module.exports = {"description":"_5D2yWc7Y","bar":"_5D3uAmLQ","empty-list":"_5D2lU4-h","search-form":"_5D2Vhk3C"};